// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon-removed-container {
  padding: 32px;
}

.coupon-removed-text {
  color: #6b7280;
  text-align: center;
}

.coupon-wrapper {
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coupon-inner-wrapper {
  width: 100%;
}

.coupon-box {
  border: 2px dashed #10b981;
  border-radius: 8px;
  padding: 16px;
  background-color: #f0fdf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.coupon-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.coupon-checkmark {
  width: 24px;
  height: 24px;
  background-color: #10b981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.coupon-text {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
}

.coupon-remove-button {
  background-color: white;
  border: 2px solid #10b981;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #10b981;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/coupons-popup/coupon.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".coupon-removed-container {\n  padding: 32px;\n}\n\n.coupon-removed-text {\n  color: #6b7280;\n  text-align: center;\n}\n\n.coupon-wrapper {\n  background-color: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.coupon-inner-wrapper {\n  width: 100%;\n}\n\n.coupon-box {\n  border: 2px dashed #10b981;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: #f0fdf4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.coupon-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.coupon-checkmark {\n  width: 24px;\n  height: 24px;\n  background-color: #10b981;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.coupon-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.coupon-remove-button {\n  background-color: white;\n  border: 2px solid #10b981;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #10b981;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
